export const RECOVERY_CAMPAIGN_PATH = 'recovery-campaign';
export const RECOVERY_CAMPAIGN_CONFIGURATION_PATH = 'configuration';

export const OCC_ANALYTICS = 'OCC_ANALYTICS';
export const OFFERS_ANALYTICS = 'OFFERS_ANALYTICS';
